import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/questionnaire/questionnaire.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-291491a2")

_pushScopeId("data-v-291491a2")
const _hoisted_1 = { class: "questionnaire-box" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("img", {
    class: "header-top-banner",
    src: _imports_0
  })
], -1)
const _hoisted_3 = { class: "questionnaire-body" }
const _hoisted_4 = { class: "questionnaire-body__main" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("h4", { style: {"color":"#7453d5"} }, "睡眠改善方案健康问卷"),
  /*#__PURE__*/_createVNode("p", { style: {"text-indent":"2em","text-align":"left"} }, " 您近来（一周）是否有以下典型症状，专家将依据提交的问卷结果和测评数据为您制定专属方案。 ")
], -1)
const _hoisted_6 = { class: "sleep-reason-item__title" }
const _hoisted_7 = { style: {"margin":"16px"} }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 提交 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_divider = _resolveComponent("van-divider")
  const _component_van_checkbox = _resolveComponent("van-checkbox")
  const _component_van_checkbox_group = _resolveComponent("van-checkbox-group")
  const _component_van_field = _resolveComponent("van-field")
  const _component_van_button = _resolveComponent("van-button")
  const _component_van_form = _resolveComponent("van-form")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_van_divider, {
          dashed: "",
          style: {"border-color":"#adbbcf"}
        }),
        _createVNode(_component_van_form, { onSubmit: _ctx.submitSleepQuestionnaireSave }, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
              return (_openBlock(), _createBlock("div", {
                key: index,
                class: "sleep-reason-item"
              }, [
                _createVNode("div", _hoisted_6, [
                  _createVNode("span", {
                    textContent: _toDisplayString(item.title + item.appendTitle)
                  }, null, 8, ["textContent"])
                ]),
                _createVNode(_component_van_field, {
                  name: item.name,
                  rules: [{required: true, message: ('请至少选择一项' + item.title), trigger: 'onChange' }]
                }, {
                  input: _withId(() => [
                    _createVNode(_component_van_checkbox_group, {
                      modelValue: item.selectedValueItems,
                      "onUpdate:modelValue": ($event: any) => (item.selectedValueItems = $event),
                      direction: "horizontal",
                      "checked-color": "#4850c4"
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.selectItems, (selectItem, selectIndex) => {
                          return (_openBlock(), _createBlock(_component_van_checkbox, {
                            key: selectIndex,
                            name: selectItem.value,
                            shape: "square"
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(selectItem.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["name"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1032, ["name", "rules"])
              ]))
            }), 128)),
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_van_button, {
                round: "",
                block: "",
                type: "primary",
                "native-type": "submit",
                color: "rgb(116, 83, 213)"
              }, {
                default: _withId(() => [
                  _hoisted_8
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ])
    ])
  ]))
})